import Input from '@/components/Input.jsx';

const OrganizationPane = ({ value, onChange }) => {
  return (
    <>
      <p className={'subtitle'}>Tell us about the organization you'd like to create.</p>
      <Input label={'Name'} value={value} onChange={(e) => onChange('name', e.target.value)} placeholder={'ACME Corp'} />
    </>
  );
};

export default OrganizationPane;
